import { Box } from "@mui/material"
import React, { useCallback } from "react"
import shapeL from "../../../../../../../../../../assets/img/morphology/shapeL.png"
import shapeRectangle from "../../../../../../../../../../assets/img/morphology/shapeRectangle.png"
import { BSBuildingMorphologyEnum } from "../../../../../../../../../core/enum/bsBuildingMorphologyEnum"

interface IProps {
  shape: BSBuildingMorphologyEnum
  width?: number | string
  height?: number | string
}

export function BSBuildingMorphologyDisplayer({ shape, width, height }: Readonly<IProps>): React.JSX.Element {
  const getImage: () => string = useCallback(() => {
    switch (shape) {
      case BSBuildingMorphologyEnum.L:
        return shapeL
      case BSBuildingMorphologyEnum.RECTANGLE:
        return shapeRectangle
      default:
        return shapeRectangle
    }
  }, [shape])

  return (
    <Box
      component="img"
      src={getImage()}
      sx={{
        width: width ?? "100%",
        height: height ?? "100%",
        objectFit: "contain",
      }}
    />
  )
}
